export const LOADING = 'LOADING';

export const LOGGED_IN = 'LOGGED_IN';

export const LOGGED_OUT = 'LOGGED_OUT';

export const UPDATE = 'UPDATE';

export const CHANGE_TPS = 'CHANGE_TPS';
